import { TNotification } from "@/types";

export default class UINotification {

    public type: TNotification;
    public message: string;
    public key: string | null;

    constructor(type: TNotification, message: string, key: string | null = null) {
        this.type = type;
        this.message = message;
        this.key = key;
    }

}
  